import React, { useState } from 'react';
import { Sidebar } from 'primereact/sidebar';
import '../resultsCapture/styleSidebar.css'

export const SidebarClinicalInfo = (props) => {
    const {
        uniqueQuestions,
        tableRows,
        visibleTop,
        setVisibleTop,
        _url_helen,
        insan,


        listAnswer,
        getAnswerText,
        setSurveyPage,
        totalSurveyPages,
        visibleSurveys,
        surveysPerPage,
        surveyPage,
        semlab,
        pyrsa

    } = props;





    return (
        <>
            {
                (_url_helen !== insan && _url_helen !== semlab && _url_helen !== pyrsa) && <Sidebar
                    className="sidebarCustom"
                    visible={visibleTop}
                    position="top"
                    onHide={() => setVisibleTop(false)}
                    style={{
                        height: 'auto',
                        maxHeight: '45vh',
                        overflowY: 'auto',
                        padding: '0.25rem',
                        borderRadius: '0 0 10px 10px',
                    }}
                >

                    <label className=' f-w-600 f-14' style={{ color: "#f97316", display: 'block', textAlign: 'center', width: '100%', marginBottom: '0.5rem' }}>
                        INFORMACIÓN CLÍNICA
                    </label>

                    <div className='table-responsive' style={{ fontSize: '10px' }}>
                        {uniqueQuestions.length === 0 ? (
                            <>
                                <hr />
                                <div style={{ textAlign: 'center', padding: '1rem' }}>
                                    <i className='icofont icofont-doctor-alt txt-danger f-32'></i>
                                    <div>
                                        <label className='f-w-600 txt-danger f-14'>No se ha realizado el proceso de toma</label>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <table className="table table-bordered table-striped" style={{ borderCollapse: 'collapse', width: '100%' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#1d5b83' }}>
                                        <th
                                            rowSpan="2"
                                            style={{
                                                verticalAlign: 'middle',
                                                fontWeight: 'bold',
                                                textAlign: 'center',
                                                color: '#ffffffff',
                                            }}
                                        >
                                            Nombre del Examen
                                        </th>
                                        {uniqueQuestions.map((preg, i) => {
                                            const isComentario = preg.toLowerCase().includes("comentario") || preg.toLowerCase().includes("flebotomista");
                                            return !isComentario ? (
                                                <th
                                                    key={i}
                                                    style={{
                                                        fontWeight: 'bold',
                                                        textAlign: 'center',
                                                        color: '#ffffffff',
                                                    }}
                                                >
                                                    {preg}
                                                </th>
                                            ) : null;
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableRows.map((fila, index) => {
                                        if (fila.type === 'Answers') {

                                            const firstExamIndex =
                                                tableRows.findIndex(
                                                    r => r.exam === fila.exam
                                                );

                                            const isFirst =
                                                firstExamIndex === index;
                                            return (
                                                <tr key={index}>
                                                    {isFirst && (
                                                        <td
                                                            rowSpan={
                                                                tableRows.filter(
                                                                    r => r.exam === fila.exam
                                                                ).length
                                                            }>
                                                            <strong>{fila.exam}</strong>
                                                        </td>
                                                    )}
                                                    {uniqueQuestions.map((preg, i) => {
                                                        const isComentario = preg.toLowerCase().includes("comentario") || preg.toLowerCase().includes("flebotomista");
                                                        return !isComentario ? (
                                                            <td key={i} style={{ textAlign: 'center' }}>
                                                                {fila[preg.toLowerCase()] || ""}
                                                            </td>
                                                        ) : null;
                                                    })}
                                                </tr>
                                            );
                                        }

                                        if (fila.type === 'Toma') {
                                            const totalCols = uniqueQuestions.filter(p => {
                                                const isComentario = p.toLowerCase().includes("comentario") || p.toLowerCase().includes("flebotomista");
                                                return !isComentario;
                                            }).length + 1;

                                            const colSpanToma = Math.max(1, Math.floor(totalCols * 0.1));
                                            const colSpanComentario = fila.isGeneral
                                                ? Math.floor(totalCols * 0.7)
                                                : Math.floor(totalCols * 0.6);

                                            const colSpanFlebotomista = fila.isGeneral
                                                ? totalCols - colSpanComentario
                                                : totalCols - colSpanToma - colSpanComentario;
                                            const rowColor1 = '#f5fcffd0';
                                            const rowColor2 = '#ffffffff';

                                            const backgroundColor = index % 2 === 0 ? rowColor1 : rowColor2;

                                            return (
                                                <tr key={index} style={{ backgroundColor }}>
                                                    {!fila.isGeneral && (
                                                        <td
                                                            colSpan={colSpanToma}
                                                            style={{
                                                                fontWeight: 'bold',
                                                                textAlign: 'center'
                                                            }}
                                                        >
                                                            TOMA {
                                                                tableRows.filter(
                                                                    r =>
                                                                        r.type === 'Toma' &&
                                                                        r.exam === fila.exam &&
                                                                        !r.isGeneral
                                                                ).indexOf(fila) + 1
                                                            }
                                                        </td>
                                                    )}

                                                    <td colSpan={colSpanComentario}>
                                                        <strong>COMENTARIO:</strong> {fila.comentario}
                                                    </td>
                                                    <td colSpan={colSpanFlebotomista}>
                                                        <strong>FLEBOTOMISTA:</strong> {fila.flebotomista}
                                                    </td>
                                                </tr>
                                            );
                                        }

                                        return null;
                                    })}

                                </tbody>

                            </table>
                        )}

                    </div>

                </Sidebar>
            }


            {
                (_url_helen === insan || _url_helen === semlab || _url_helen === pyrsa) && <Sidebar
                    className="sidebarCustom"
                    visible={visibleTop}
                    position="top"
                    onHide={() => setVisibleTop(false)}
                    style={{
                        height: 'auto',
                        maxHeight: '95vh',
                        overflowY: 'auto',
                        padding: '0.25rem',
                        borderRadius: '0 0 10px 10px',
                    }}
                >
                    <div className="capture-result-container">

                        {
                            Array.isArray(listAnswer) &&
                                listAnswer.length > 0 ? (
                                <>
                                    <div className="capture-result-carousel">
                                        {
                                            totalSurveyPages > 1 && (
                                                <button
                                                    type="button"
                                                    className="capture-result-carousel-button capture-result-carousel-prev"
                                                    disabled={surveyPage === 0}
                                                    onClick={() =>
                                                        setSurveyPage(
                                                            prev =>
                                                                Math.max(
                                                                    prev - 1,
                                                                    0
                                                                )
                                                        )
                                                    }
                                                >
                                                    <i className="fa fa-chevron-left"></i>
                                                </button>
                                            )
                                        }

                                        <div className="row">
                                            {
                                                visibleSurveys.map(
                                                    (
                                                        _itemAnswer,
                                                        _surveyIndex
                                                    ) => (

                                                        <div
                                                            className={
                                                                listAnswer.length === 1
                                                                    ? "col-12 mb-3 pl-0"
                                                                    : "col-12 col-lg-6 mb-3 pl-0"
                                                            }
                                                            key={
                                                                _itemAnswer?.id_survey_answer ??
                                                                _surveyIndex
                                                            }
                                                        >
                                                            <div className="capture-result-survey-card">
                                                                <div className="capture-result-survey-header">
                                                                    <div className="capture-result-survey-header-left">

                                                                        <div className="capture-result-survey-icon">
                                                                            <i className="fa fa-file-text-o f-16"></i>
                                                                        </div>

                                                                        <div className="capture-result-survey-info">
                                                                            <div className="capture-result-survey-label">
                                                                                Consentimiento aplicado
                                                                            </div>
                                                                            <h4 className="capture-result-survey-title">
                                                                                {_itemAnswer?.title ?? ""}
                                                                            </h4>

                                                                            <div className="capture-result-survey-meta">
                                                                                <span>
                                                                                    <i className="fa fa-tag f-14"></i>
                                                                                    Versión {_itemAnswer?.version ?? ""}
                                                                                </span>

                                                                                <span>
                                                                                    <i className="fa fa-list-ol f-14"></i>
                                                                                    {
                                                                                        Array.isArray(_itemAnswer?.answers) ? _itemAnswer.answers.length : 0
                                                                                    }
                                                                                    preguntas
                                                                                </span>
                                                                            </div>

                                                                        </div>
                                                                    </div>

                                                                    <div className="capture-result-survey-status">
                                                                        <i className="fa fa-calendar"></i>
                                                                        {
                                                                            _itemAnswer?.examSample?.find(item => item?.question === "Fecha de la toma")?.answer || "Sin fecha"
                                                                        }
                                                                    </div>
                                                                </div>

                                                                <div className="capture-result-body   capture-result-body-scroll">

                                                                    <div className="capture-result-left">


                                                                        {
                                                                            Array.isArray(_itemAnswer?.examSample) && _itemAnswer?.examSample.length > 0 && (
                                                                                <div className="capture-result-sample-section">
                                                                                    {
                                                                                        _itemAnswer?.examSample.filter(item => item?.question === "¿Estudios?").map(
                                                                                            (
                                                                                                _item,
                                                                                                _index
                                                                                            ) => (

                                                                                                <div
                                                                                                    className="capture-result-sample-item"
                                                                                                    key={`exam-${_index}`}
                                                                                                >
                                                                                                    <div className="capture-result-sample-item-icon">
                                                                                                        <i className="fa fa-flask f-14"></i>
                                                                                                    </div>

                                                                                                    <div className="capture-result-sample-item-content">
                                                                                                        <span className="capture-result-sample-label">
                                                                                                            {_item?.question ?? ""}
                                                                                                        </span>

                                                                                                        <strong className="capture-result-sample-value capture-result-sample-exams">
                                                                                                            {_item?.answer || "Sin datos"}
                                                                                                        </strong>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )
                                                                                        )
                                                                                    }

                                                                                    <div className="capture-result-phlebotomy-card">
                                                                                        <div className="capture-result-phlebotomy-title">
                                                                                            <i className="fa fa-user-md"></i>
                                                                                            <span>
                                                                                                Información de flebotomía
                                                                                            </span>
                                                                                        </div>

                                                                                        <div className="capture-result-phlebotomy-row">
                                                                                            <div className="capture-result-phlebotomy-icon">
                                                                                                <i className="fa fa-comment-o"></i>
                                                                                            </div>

                                                                                            <div className="capture-result-phlebotomy-content">
                                                                                                <span className="capture-result-sample-label">
                                                                                                    Comentario
                                                                                                </span>

                                                                                                <strong className="capture-result-sample-value">
                                                                                                    {
                                                                                                        _itemAnswer?.examSample.find(item => item?.question === "¿Comentario?")?.answer || "Sin datos"
                                                                                                    }
                                                                                                </strong>
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="capture-result-phlebotomy-row">
                                                                                            <div className="capture-result-phlebotomy-icon">
                                                                                                <i className="fa fa-user-md"></i>
                                                                                            </div>

                                                                                            <div className="capture-result-phlebotomy-content">
                                                                                                <span className="capture-result-sample-label">
                                                                                                    Flebotomista responsable
                                                                                                </span>

                                                                                                <strong className="capture-result-sample-value">
                                                                                                    {
                                                                                                        _itemAnswer?.examSample.find(item => item?.question === "Flebotomista responsable")?.answer || "Sin datos"
                                                                                                    }
                                                                                                </strong>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        }
                                                                    </div>

                                                                    <div className="capture-result-table-container">
                                                                        <table className="capture-result-table">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th className="capture-result-table-number"> #</th>
                                                                                    <th>  Pregunta</th>
                                                                                    <th> Respuesta  </th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {
                                                                                    Array.isArray(_itemAnswer?.answers) &&
                                                                                    _itemAnswer.answers.map(
                                                                                        (
                                                                                            _answer,
                                                                                            _index
                                                                                        ) => {

                                                                                            const answerText = getAnswerText(_answer);

                                                                                            return (
                                                                                                <tr key={_answer?.id_question_answer ?? _index}>
                                                                                                    <td className="capture-result-table-number">
                                                                                                        <span className="capture-result-table-question-number">
                                                                                                            {_index + 1}
                                                                                                        </span>
                                                                                                    </td>

                                                                                                    <td className="capture-result-table-question">
                                                                                                        {_answer?.question}
                                                                                                    </td>

                                                                                                    <td className="capture-result-table-answer">
                                                                                                        {
                                                                                                            Array.isArray(_answer?.selected_options) && _answer.selected_options.length > 0 ? (
                                                                                                                <div className="capture-result-table-options">
                                                                                                                    {
                                                                                                                        _answer.selected_options.map(
                                                                                                                            (
                                                                                                                                _option,
                                                                                                                                _optionIndex
                                                                                                                            ) => (
                                                                                                                                <span
                                                                                                                                    className="capture-result-table-option"
                                                                                                                                    key={_option?.id_option ?? _optionIndex}
                                                                                                                                >
                                                                                                                                    <i className="fa fa-check"></i>
                                                                                                                                    {_option?.text}
                                                                                                                                </span>
                                                                                                                            )
                                                                                                                        )
                                                                                                                    }
                                                                                                                </div>
                                                                                                            )
                                                                                                                : (
                                                                                                                    <span className={answerText === "Sin respuesta" ? "capture-result-table-value capture-result-table-empty" : "capture-result-table-value"}  >
                                                                                                                        {
                                                                                                                            _answer?.type === "time" && (
                                                                                                                                <i className="fa fa-clock-o"></i>
                                                                                                                            )
                                                                                                                        }
                                                                                                                        {
                                                                                                                            answerText ?? ""
                                                                                                                        }
                                                                                                                    </span>

                                                                                                                )
                                                                                                        }
                                                                                                    </td>
                                                                                                </tr>
                                                                                            );

                                                                                        }
                                                                                    )
                                                                                }
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                )
                                            }
                                        </div>
                                        {
                                            totalSurveyPages > 1 && (
                                                <button
                                                    type="button"
                                                    className=" capture-result-carousel-button   capture-result-carousel-next  "
                                                    disabled={surveyPage >= totalSurveyPages - 1}
                                                    onClick={() =>
                                                        setSurveyPage(
                                                            prev =>
                                                                Math.min(
                                                                    prev + 1,
                                                                    totalSurveyPages - 1
                                                                )
                                                        )
                                                    }
                                                >
                                                    <i className="fa fa-chevron-right"></i>
                                                </button>
                                            )
                                        }
                                    </div>
                                    {
                                        totalSurveyPages > 1 && (
                                            <div className="capture-result-carousel-dots">
                                                {
                                                    Array.from({ length: totalSurveyPages },
                                                        (
                                                            _,
                                                            index
                                                        ) => (
                                                            <button
                                                                key={index}
                                                                type="button"
                                                                className={surveyPage === index ? "capture-result-carousel-dot active" : "capture-result-carousel-dot"}
                                                                onClick={() =>
                                                                    setSurveyPage(
                                                                        index
                                                                    )
                                                                }
                                                            />
                                                        )
                                                    )
                                                }
                                            </div>
                                        )
                                    }
                                </>
                            ) : (
                                <div className="capture-result-empty">
                                    <div className="capture-result-empty-icon">
                                        <i className="fa fa-file-text-o"></i>
                                    </div>
                                    <h5>
                                        Sin respuestas registradas
                                    </h5>
                                    <p>
                                        No se encontraron consentimientos contestados
                                        para esta muestra.
                                    </p>
                                </div>
                            )
                        }
                    </div>
                </Sidebar>
            }
        </>
    );
};
